import { render, staticRenderFns } from "./gpg.vue?vue&type=template&id=b4efa89a&scoped=true"
import script from "./gpg.vue?vue&type=script&lang=js"
export * from "./gpg.vue?vue&type=script&lang=js"
import style0 from "./gpg.vue?vue&type=style&index=0&id=b4efa89a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_84097bf1da1fe89cf094ff7a2cbe4d08/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4efa89a",
  null
  
)

export default component.exports